export default ((keyCode, current, last) => {
  const next = {
    // Down - Move to the next item
    40: current === last ? current : current + 1,
    // Up - Move to the previous item.
    38: current === 0 ? current : current - 1,
    // Home - Move to the first item
    36: 0,
    // End - Move to the last item
    35: last
  };
  return next[keyCode];
});